// assets/tagada-checkout.js
window.TagadaCheckout = {
  defaultStoreId: 'store_a4c981513dff',
  defaultCheckoutUrl: 'https://secure.sleepwhale.com/',
  baseApiUrl: 'https://app.tagadapay.com/api/public/v1/checkout/init',
  defaultFunnelId: "funnelv2_08d1bd94cdd3",

  generateUrl: function({ variantId, priceId, checkoutUrl, quantity = 1,  }) {
    if (!variantId) {
      console.error('Tagada Checkout: variantId is required');
      return null;
    }

    const item = { variantId, quantity };
    if (priceId) item.priceId = priceId;

    const params = new URLSearchParams({
      currency: 'USD',
      items: JSON.stringify([item]),
      storeId: this.defaultStoreId,
      checkoutUrl: this.defaultCheckoutUrl + checkoutUrl
    });

    params.append('funnelId', this.defaultFunnelId);
    params.append('includeCheckoutToken', 'checkoutToken');

    return this.baseApiUrl + '?' + params.toString();
  },

  redirect: function(config) {
    const url = this.generateUrl(config);
    console.log('url:', url)
    if (url) {
      window.location.href = url;
    }
  }
};


// <script src="{{ 'tagada-checkout.js' | asset_url }}" defer></script>

// // --- TAGADA CHECKOUT ROUTING ---
// if (offer.enableTagada) {
//   if (typeof window.TagadaCheckout === 'undefined') {
//     console.error('TagadaCheckout utility is missing.');
//     alert('Checkout is currently unavailable. Please try again.');
//     this.loading = false;
//     return;
//   }

//   if (!offer.tagadaVariantId) {
//     alert('Tagada Variant ID is required when Tagada is enabled.');
//     this.loading = false;
//     return;
//   }

//   // Only pass the priceId if the user has selected 'subscription'
//   const activePriceId = this.purchaseType === 'subscription' ? offer.tagadaPriceId : null;

//   window.TagadaCheckout.redirect({
//     variantId: offer.tagadaVariantId,
//     priceId: activePriceId,
//     funnelId: offer.tagadaFunnelId
//   });

//   return; // Exit function so standard Shopify cart logic doesn't run
// }

// // --- STANDARD SHOPIFY CHECKOUT ROUTING ---
// // (Keep the rest of your standard Shopify checkout fetch code here)

